<template>
  <div class="blur-overlay flex items-center justify-center text-center px-16">
    <div class="banner flex items-center gap-4 p-4 rounded-2xl bg-white">
      <div class="w-11 h-11 flex items-center justify-center bg-neutral-25 rounded-full">
        <LockedIcon class="text-icon-normal" />
      </div>
      <BaseText type="label" size="sm" class="text-text-muted text-left" style="max-width: 250px;">
        {{ text }}
      </BaseText>
      <BasePrimaryButton 
        class="pointer-events-auto mr-2"
        text="Start Tracking"
        @click="trackBrand"
      />
    </div>
  </div>
</template>

<script>
import EventBus from '@/plugins/BaseNotifications/EventBus'
import LockedIcon from '@/components/globals/Icons/LockedIconV2.vue'

export default {
  name: 'CreativeTestsLockedOverlay',
  components: {
    LockedIcon
  },
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  methods: {
    trackBrand () {
      EventBus.$emit('spyder:track-brand')
    }
  }
}
</script>

<style scoped>
.blur-overlay {
  background-color: rgba(255, 255, 255, 0.24);
  backdrop-filter: blur(10px);
}
.banner {
  box-shadow: 0 6px 12px -3px rgba(24, 35, 68, 0.04), 0 2px 4px -1.5px rgba(24, 35, 68, 0.04), 0 1px 2px -0.75px rgba(24, 35, 68, 0.04);
}
</style>